var Class   = require("Class"),
    utils   = require("Utils");

var Model = Class.extend({

    /**
     * Уникальный идентификатор модели который генерируется при ее создании
     *
     * @property {Number} guid
     */
    guid: undefined,

    initialize: function(attributes, options){
        var that = this,
            attrs;

        that._attributes = {};

        attrs = attributes || {};

        options = options || {};
        that.setOptions(options);

        that.set(attrs);
        utils.stamp(that, 'guid');
    },

    get: function(attrName){
        return this._attributes[attrName];
    },

    set: function(attr, value) {
        var that = this,
            attrs,
            i;

        if (typeof attr === "string") {
            attrs = {};
            attrs[attr] = value;
        } else {
            attrs = attr;
        }

        for( i in attrs) {
            that._attributes[i] = attrs[i];
        }
    }
});

module.exports = Model;



//////////////////
// WEBPACK FOOTER
// ./src/~/Model.js
// module id = 7
// module chunks = 0